// src/firebase.js
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyCo9pv7HEv4tYcUVlXfOKkxRYK7lRFeM-s",
    authDomain: "cyber-bot-234.firebaseapp.com",
    projectId: "cyber-bot-234",
    storageBucket: "cyber-bot-234.firebasestorage.app",
    messagingSenderId: "544067592699",
    appId: "1:544067592699:web:05fae4f10ace80c8cf2b5e"
  };
initializeApp(firebaseConfig);
